var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIconSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 64,
    rx: 10,
    fill: "#6E5E26"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.078 36.62c-1.187-1.188-3.137-1.188-4.268.027l-.056.057c-1.244 1.385-3.364 1.498-4.664.198l-5.964-5.992c-1.3-1.3-1.187-3.42.198-4.664l.057-.056c1.215-1.13 1.215-3.081.028-4.268l-5.06-5.031c-1.215-1.216-3.193-1.187-4.324.085-.621.678-1.074 1.498-1.384 2.459 0 .028-.029.056-.029.113-1.582 5.285-.028 10.994 3.872 14.895l9.073 9.073c3.9 3.9 9.61 5.455 14.895 3.872.029 0 .057-.029.113-.029a6.192 6.192 0 002.46-1.384c1.271-1.131 1.3-3.11.084-4.325l-5.03-5.03z",
    fill: "#F9C106"
  })));
}
export default SvgPhoneIconSvg;